export default __webpack_public_path__ + "static/media/03.05192279.jpg";